"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getIntegerFromUnknown_1 = __importDefault(require("../../shared/getIntegerFromUnknown"));
const randomNumberBuilder = () => ({ entryVars: { min: entryMin, max: entryMax, }, functionId, callbacks, executeProcesses, }) => {
    try {
        const min = (0, getIntegerFromUnknown_1.default)(entryMin);
        const max = (0, getIntegerFromUnknown_1.default)(entryMax);
        const ranNumber = Math.round(Math.random() * (max - min) + min);
        executeProcesses(functionId, callbacks.success, ranNumber);
    }
    catch (_a) {
        executeProcesses(functionId, callbacks.onError, `Invalid min or max: [${entryMin},${entryMax}]`);
    }
};
exports.default = randomNumberBuilder;
